import script from "./AbsenceDocumentAttachment.vue?vue&type=script&setup=true&lang=js"
export * from "./AbsenceDocumentAttachment.vue?vue&type=script&setup=true&lang=js"

import "./AbsenceDocumentAttachment.vue?vue&type=style&index=0&id=5c44b050&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c44b050"]])

export default __exports__